import { INavData } from '@coreui/angular';

export const navItems: INavData[] = [
   {
      "name":"Dashboard",
      "url":"/dashboard",
      "icon":"icon-speedometer"
   },
   {
      "name":"Settings",
      "url":"/settings",
      "icon":"icon-speedometer",
      "children":[
         {
            "name":"Communication",
            "url":"/settings/communication/view",
            "icon":"icon-speedometer",
           
         },
         {
            "name":"Customer Type",
            "url":"/settings/customertype/view",
            "icon":"icon-speedometer",
           
         },
         {
            "name":"Lead Sources",
            "url":"/settings/source/view",
            "icon":"icon-speedometer",
           
         },
         {
            "name":"Lead Types",
            "url":"/settings/type/view",
            "icon":"icon-speedometer",
           
         },
         {
            "name":"Payment Modes",
            "url":"/settings/paymentmodes",
            "icon":"icon-circle"
         },
         {
            "name":"Segments",
            "url":"/settings/segments",
            "icon":"icon-circle"
         }
      ]
   },
   {
      "name":"Packages",
      "url":"/packages",
      "icon":"icon-speedometer",
      "children":[
         {
            "name":"Service Categories",
            "url":"/packages/servicecategories",
            "icon":"icon-circle"
         },
         {
            "name":"Services",
            "url":"/packages/services",
            "icon":"icon-circle"
         },
         {
            "name":"Service Types",
            "url":"/packages/servicetypes",
            "icon":"icon-circle"
         }
      ]
   },
   {
      "name":"Leads",
      "url":"/leads/view",
      "icon":"icon-speedometer",
        "children":[
            {
            "name":"Leads",
            "url":"/leads/view",
            "icon":"icon-circle"
         },{
            "name":"Enquiries",
            "url":"/leads/enquiries",
            "icon":"icon-circle"
         }
            
        ]
      
   },
   {
      "name":"Customers",
      "url":"/customers ",
      "icon":"icon-speedometer",
      "children":[
         {
            "name":"Customers",
            "url":"/customers/view",
            "icon":"icon-circle",
            
         },
         {
            "name":"Customer Services",
            "url":"/customers/customerservices/view",
            "icon":"icon-circle",
            
         },
         {
            "name":"Customer Tags",
            "url":"/customers/customertags/view",
            "icon":"icon-circle",
           
         },
         {
            "name":"Tags",
            "url":"/customers/tags/view",
            "icon":"icon-circle",
           
         }
      ]
   },
   {
      "name":"Staff",
      "url":"/staff ",
      "icon":"icon-speedometer",
      "children":[
         {
            "name":"Roles",
            "url":"/staff/roles",
            "icon":"icon-circle"
         },
         {
            "name":"Users",
            "url":"/staff/users",
            "icon":"icon-circle"
         }
      ]
   },
    {
      "name":"Volunteers",
      "url":"/volunteers/view",
      "icon":"icon-speedometer"
   },
   {
      "name":"Deekshe",
      "url":"/deekshe ",
      "icon":"icon-speedometer",
      "children":[
         {
            "name":"Enrollment",
            "url":"/deekshe/enrollment",
            "icon":"icon-circle"
         },
         {
            "name":"Feedback",
            "url":"/deekshe/feedback",
            "icon":"icon-circle"
         }
      ]
   },
   {
     "name":"Receipts",
     "url":"/receipt/view",
     "icon":"icon-speedometer"
  }
];
